import { lazy } from "react";

export const EditWireframeTabs = lazy(() => import("./EditWireframeTabs"));
